import * as React from 'react'
import * as st from './packshot.module.scss'
import { CirclePlayButton } from '../circlePlayButton/circlePlayButton'
import * as cn from 'classnames'
import { ResponsiveImage } from '../images/responsiveImage'
import { isTreatment } from '../../utils/utils'
import { IDetailPageState} from "../../reducers";
import { isRetailSelector, marketplaceIdSelector } from '../../selectors/requestContext'
import { simpleSelectors } from '../../selectors/basicState'
import { isTVSelector } from '../../selectors/shared'
import { isDeeplinkableActionReadySelector } from '../../selectors/pageContext'
import { imagesSelector } from '../../selectors/detailFragment'
import { heroshotShouldBeShownSelector } from '../../selectors/component/atfComponentSelectors'
import { playbackFirstChildSelector } from '../../selectors/actionFragment'
import { connect } from 'react-redux'

type StateProps = ReturnType<typeof mapStateToProps>
export type Props = StateProps

export const PackshotConnected = ({ images, playbackData, isRetail, isTV,
                                    isDeeplinkableActionReady, heroshotShouldBeShown, atfTreatment }: Props) => {
  if (heroshotShouldBeShown || !(images && images.packshot)) {
    return null
  }

  const packshotImgProps = {
    alt: '', // Decorative image so no alt
    src: images.packshot,
    baseValue: isTreatment(atfTreatment, 'T1', 'T2', 'T3') ? 600 : 300,
  }

  const packshotClassNames = cn(
    isTreatment(atfTreatment, 'T1', 'T2', 'T3') ? st.packshotRedesign : st.packshot,
    isTV ? (isTreatment(atfTreatment, 'T1', 'T2', 'T3') ? st.seasonPackshotRedesign : st.seasonPackshot) : undefined,
    'dv-fallback-packshot-image'
  )

  return (
    <React.Fragment>
      <div className={packshotClassNames}>
        {isTreatment(atfTreatment, 'T1', 'T2', 'T3') ?
          <span className={st.imageWrapper}>
            <ResponsiveImage {...packshotImgProps} />
            {isTreatment(atfTreatment,'T3') && isRetail && playbackData && isDeeplinkableActionReady &&
            <CirclePlayButton playbackData={playbackData} isPackshot atfTreatment={atfTreatment}/>}
          </span>
        :
          <>
            <ResponsiveImage {...packshotImgProps} />
            {isRetail && (
              <div className="playback-large-circle-wrapper">
                <div id="dv-play-box-circle">
                  {playbackData && isDeeplinkableActionReady && (
                    <CirclePlayButton playbackData={playbackData} isPackshot/>
                  )}
                </div>
              </div>
            )}
          </>
        }
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state: IDetailPageState) => ({
  isRetail: isRetailSelector(state),
  isTV: isTVSelector(state),
  isDeeplinkableActionReady: isDeeplinkableActionReadySelector(state),
  marketplaceId: marketplaceIdSelector(state),
  images: imagesSelector(state),
  heroshotShouldBeShown: heroshotShouldBeShownSelector(state),
  playbackData: playbackFirstChildSelector(state),
  atfTreatment: simpleSelectors.atfTreatment(state)
})

export const Packshot = connect(mapStateToProps)(PackshotConnected)
